import React, { useEffect, useMemo, useState } from 'react';
import { Col, Layout, Row } from 'tea-component';
import ContextualNearbyReviews from './components/ContextualNearbyReviews';
import Reviews from './components/Reviews';
import { connect, useHistory, useIntl, useParams } from 'umi';
import { useFeedsCommentItem } from './hooks';
import { getGameIdIsSame, setUrlInfo } from '@/pages/opinion/utils/url';
import { getViaDetailFlagKey } from '@/pages/opinion/constants/page';
import './index.scss';
import type { LanguageType } from '@/pages/opinion/types/common';
import FilterBoxCommon from '@/pages/opinion/components/FilterBoxCommon';
import { getTimeSlot } from '@/pages/opinion/utils/time';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import TagCard from '@op/pages/community/video/components/TagCard';
const { Body, Content } = Layout;
const FeedsDetails = ({
  userInfo,
  gameInfo,
  userInfoLoading,
  location,
  wholeGameInfo,
}: any) => {
  const { mainItem, loading, getFeedsContents, empty } = useFeedsCommentItem();
  const history = useHistory();
  const [feedsSource, setFeedsSource] = useState('');
  const [language, setLanguage] = useState<LanguageType>(
    location.query.language || 'origin',
  );
  const { Sentiment_Rating } = useGetSingePageSourceRule({
    keys: 'Sentiment_Rating',
  });
  // const { hasSentimentSentences } = useSentimentSentences({
  //   request: true,
  //   gameInfo: gameInfo,
  // });

  const [showSentiment, setShowSentiment] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const params: any = useParams();
  const { formatMessage } = useIntl();
  const needVideoTags = useMemo(() => {
    if (gameInfo?.edition_unified_id === 'ufc454d9b1af70b40588e2a6fa4da4a8b') {
      return true;
    }
    return false;
  }, [gameInfo]);
  useEffect(() => {
    const { isSameId } = getGameIdIsSame(gameInfo);
    if (isSameId && gameInfo) {
      const { id } = params || {};
      const { comment_time, feed_source } = location.query;
      const timeParams = getTimeSlot(comment_time);
      let requestParams = { comment_uins: [id], ...gameInfo, ...timeParams, need_video_tags: needVideoTags };
      if (feed_source) {
        requestParams = { ...requestParams, feed_source };
      }
      setFeedsSource(feed_source);
      getFeedsContents(requestParams);
    }
  }, [gameInfo, params, needVideoTags]);

  const filterBoxChange = (value: any, key?: string) => {
    setShowSentiment(value.showSentiment);
    if (
      value.showSentiment &&
      key === 'showSentiment' &&
      value.language !== 'en'
    ) {
      value.language = 'en';
    }
    setLanguage(value.language);
    setUrlInfo({ language: value.language }, history);
  };
  const tagList = useMemo(() => {
    const { video_tags } = mainItem || {};
    if (!video_tags) return [];

    try {
      const tagList = JSON.parse(video_tags);
      return tagList;
    } catch (err) {
      console.error('Invalid JSON in video_tags:', err);
      return [];
    }
  }, [mainItem]);

  const showTagCard = useMemo(() => {
    return needVideoTags && tagList?.length > 0;
  }, [needVideoTags, tagList]);


    



  return (
    <Layout className="dbo-feeds-details">
      <Body>
        <Content>
          <Content.Header
            showBackButton
            onBackButtonClick={() => {
              // 标记从详情页返回，供上游页面判断是否恢复定位
              sessionStorage.setItem(getViaDetailFlagKey(gameInfo?.edition_unified_id), '1');
              const redirectPath = location.query.redirect_path;
              if (redirectPath) {
                history.push(decodeURIComponent(redirectPath));
              } else {
                history.go(-1);
              }
            }}
            title={formatMessage({ id: 'Details' })}
          />
          <Content.Body full>
            <FilterBoxCommon
              className="dbo-details-language"
              left={[
                {
                  key: 'language',
                  defaultValue: language,
                },
                // {
                //   key: 'singleCheckbox',
                //   valueKey: 'showSentiment',
                //   defaultValue: showSentiment,
                //   defaultParams: {
                //     text: 'Sub Sentiment',
                //     tipsMap: commonSentimentSentencesTips,
                //   },
                //   show: !Sentiment_Rating,
                // },
              ]}
              onChange={filterBoxChange}
              right={[]}
            ></FilterBoxCommon>
            <Row className='dbo-feeds-details-row'>
              <Col span={showTagCard ? 16 : 24}>
                <Reviews
                  language={language}
                  loading={loading || userInfoLoading}
                  userInfo={userInfo}
                  gameInfo={gameInfo}
                  empty={empty}
                  isShowSentiment={showSentiment}
                  data={mainItem}
                  feedsSource={feedsSource}
                  wholeGameInfo={wholeGameInfo}
                  setTableLoading={setTableLoading}
                />
              </Col>
              <>
                {
                  showTagCard && (
                    <Col span={8}>
                      <TagCard
                        list={tagList}
                        loading={loading || userInfoLoading || tableLoading}
                        contentCard={false}
                        loadingHeight={275}
                        emptyHeight={275}
                      />
                    </Col>
                  )
                }
              </>
            </Row>
            <ContextualNearbyReviews
              gameInfo={gameInfo}
              language={language}
              data={mainItem}
              feedsSource={feedsSource}
              isShowSentiment={showSentiment}
              loading={loading || userInfoLoading}
              empty={empty}
            />
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default connect((state: any) => {
  const { home, opinionCommon, loading } = state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(FeedsDetails);
